const compoundInterestCalculatorFormActionTypes = {
    UPDATE_INITIAL_DEPOSIT_AMOUNT: 'UPDATE_INITIAL_DEPOSIT_AMOUNT',
    UPDATE_MONTHLY_DEPOSIT_AMOUNT: 'UPDATE_MONTHLY_DEPOSIT_AMOUNT',
    UPDATE_ANNUAL_INTEREST: 'UPDATE_ANNUAL_INTEREST',
    UPDATE_PERIOD_OF_INVESTMENT_IN_YEARS: 'UPDATE_PERIOD_OF_INVESTMENT_IN_YEARS',
    UPDATE_TOTAL_DEPOSIT_AMOUNT: 'UPDATE_TOTAL_DEPOSIT_AMOUNT',
    UPDATE_FUTURE_VALUE: 'UPDATE_FUTURE_VALUE',
    UPDATE_PROFIT: 'UPDATE_PROFIT',
    UPDATE_MANAGEMENT_FEE_PERCENT_FROM_DEPOSIT: 'UPDATE_MANAGEMENT_FEE_PERCENT_FROM_DEPOSIT',
    UPDATE_MANAGEMENT_FEE_PERCENT_FROM_THE_ACCRUAL: 'UPDATE_MANAGEMENT_FEE_PERCENT_FROM_THE_ACCRUAL',
    UPDATE_TOTAL_MANAGEMENT_FEE_SUM_FROM_DEPOSIT: 'UPDATE_TOTAL_MANAGEMENT_FEE_SUM_FROM_DEPOSIT',
    UPDATE_TOTAL_MANAGEMENT_FEE_SUM_FROM_THE_ACCRUAL: 'UPDATE_TOTAL_MANAGEMENT_FEE_SUM_FROM_THE_ACCRUAL',
    UPDATE_LOST_OF_PROFITS_FROM_MANAGEMENT_FEES: 'UPDATE_LOST_OF_PROFITS_FROM_MANAGEMENT_FEES',
    UPDATE_TAX: 'UPDATE_TAX',
};

export const updateInputAction = (type, value, isValid, errorMessage = '') => ({
    type,
    payload: {
        value,
        isValid,
        errorMessage,
    },
});

export default compoundInterestCalculatorFormActionTypes;